import React, { useState, useRef, useEffect, useCallback } from "react";
import PinkButton from "../component/PinkButton";
import CarImageForm from "../component/CarImageForm";
import layout_text from "../assets/json/layout_text.json";
import Relax from "../assets/img/timer.png";
import Odometer from "../assets/img/odometer.png";
import { useQuery } from "../hooks/useQuery";
import { FileInput } from "../component/Inputs";
import { submitMonthlyCarPictures } from "../hooks/apiCalls";

const MonthlyCheck = () => {
  let query = useQuery();
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [popup, setPopup] = useState(false);
  const [preCarImages, setPreCarImages] = useState({
    car_front: "",
    car_back: "",
    car_left: "",
    car_right: "",
    odometer: "",
    odometer_number: 0
  });

  const [hasError, setHasError] = useState(false);
  const [hasRead, setHasRead] = useState(false);
  const [showHasReadError, setShowHasReadError] = useState(false);

  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!query.get("userAuth")) {
    }
  }, []);

  const useOutsideAlerter = useCallback(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        // alert("You clicked outside of me!");
        setPopup(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  const handleNext = async () => {
    let err = false;
    switch (step) {
      case 0:
        //step 1
        Object.keys(preCarImages).forEach((image) => {
          if (image !== "odometer") {
            if (preCarImages[image] === "") {
              err = true;
            }
          }
        });
        setHasError(err);

        if (!err) {
          setStep(step + 1);
        }

        break;
      case 1:
        //step 2
        if (preCarImages.odometer === "" || preCarImages.odometer_number <= 0) {
          err = true;
        }

        setHasError(err);

        if (!err) {
          setPopup(true);
        }
        break;
      default:
        break;
    }
  };

  const handleTnCSubmit = async () => {
    if (hasRead) {
      setShowHasReadError(false);
      if (step === 1) {
        await handlePreSubmit();
      }
    } else {
      setShowHasReadError(true);
    }
  };

  const handlePreSubmit = async () => {
    setIsLoading(true);
    var response = await submitMonthlyCarPictures({
      pictures: {
        car_front: preCarImages.car_front,
        car_back: preCarImages.car_back,
        car_left: preCarImages.car_left,
        car_right: preCarImages.car_right,
        odometer: preCarImages.odometer,
        odometer_number: preCarImages.odometer_number
      },
      bearerToken: query.get("userAuth")
    });

    if (response.data.success) {
      setStep(step + 1);
      setPopup(false);
      setIsLoading(false);
    } else {
      console.log("error", response);
      setIsLoading(false);
    }
  };

  const preConstant = [
    "In order to reward you with your points, we will require up to 5 working days to validate the odometer reading submitted."
  ];

  useOutsideAlerter(wrapperRef);
  // useOutsideAlerter()
  return (
    <>
      {query.get("userAuth") ? (
        <div className="min-h-screen flex flex-col">
          {popup && (
            <div className="w-full h-screen backdrop-blur-sm bg-white/30 z-10 absolute top-0 left-0 p-5 flex justify-center items-center">
              <div
                className="bg-white p-5 rounded-xl shadow-lg w-full"
                ref={wrapperRef}
              >
                <div className="mb-4">
                  <p
                    className="text-carching-pink"
                    style={{ textAlign: "center" }}
                  >
                    monthly submission
                  </p>
                </div>

                {preConstant.map((value) => (
                  <div
                    className="mb-4"
                    key={value}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <p
                      style={{
                        fontSize: "13px",
                        fontFamily: "Fredoka One",
                        textAlign: "center"
                      }}
                    >
                      {value}
                    </p>
                  </div>
                ))}

                <div className="w-full flex items-center mb-2">
                  <input
                    type="checkbox"
                    className="checked:bg-blue-500 mr-2 cursor-pointer"
                    id="tnc-agree"
                    checked={hasRead}
                    onChange={() => setHasRead(!hasRead)}
                  />
                  <label
                    htmlFor="tnc-agree"
                    className="cursor-pointer"
                    style={{
                      fontFamily: "Fredoka One",
                      fontSize: "12px",
                      marginLeft: "5px"
                    }}
                  >
                    I accept the above, and hereby confirm that the images
                    provided is complete and correct. Any incorrect or blurred
                    images will delay the approval process of the points
                    rewarded.
                  </label>
                </div>
                {showHasReadError && (
                  <p className="text-red-500 mb-2">
                    Please agree to the terms and conditions
                  </p>
                )}
                <PinkButton
                  text="submit"
                  loading={isLoading}
                  onClick={() => handleTnCSubmit()}
                />
              </div>
            </div>
          )}
          {/* <TopInfo appointmentDetails={appointmentDetails} /> */}
          <div className="p-4 flex-1 flex flex-col justify-center items-center">
            <div className="top flex-1 flex">
              {step === 0 && (
                <CarImageForm get={preCarImages} set={setPreCarImages} />
              )}

              {step === 1 && (
                <div className="flex-1 flex items-center justify-center flex-col">
                  <img src={Odometer} alt="" className="mb-8" />
                  <FileInput
                    name="odometer"
                    label="odometer"
                    onChange={({ converted }) =>
                      setPreCarImages({ ...preCarImages, odometer: converted })
                    }
                  />
                  <br />
                  <div>
                    <label
                      htmlFor="price"
                      className="block text-sm font-medium leading-6 text-carching-pink"
                    >
                      Odometer Number(km)
                    </label>
                    <div className="relative mt-2 rounded-md shadow-sm">
                      <input
                        type="number"
                        name="odometer_number"
                        id="odometer_number"
                        className="block w-full rounded-md border-0 py-1.5 pl-7 pr-20 text-carching-pink ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        placeholder="1000 (km)"
                        onChange={(e) => {
                          setPreCarImages({
                            ...preCarImages,
                            odometer_number: Number(e.target.value)
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
              {step === 2 && (
                <div
                  className="w-full flex flex-col justify-center items-center flex-1"
                  style={{ padding: "15px", textAlign: "center" }}
                >
                  <img src={Relax} alt="" style={{ width: "20%" }} />
                  <p
                    className="text-carching-pink mb-4 text"
                    style={{ fontFamily: "Fredoka One", marginTop: 20 }}
                  >
                    thank you for providing the images for points validation.
                  </p>

                  <p
                    className="text-carching-pink mb-20 text"
                    style={{ fontFamily: "Roboto" }}
                  >
                    You will be notified when your points have been validated.
                    Please note that this process might take 3 to 5 working
                    days.
                  </p>
                </div>
              )}
            </div>

            <div className="page-bottom w-full max-w-lg">
              <div className="text-center mb-4">
                <p
                  className={`text transition ${
                    hasError
                      ? "animate-bounce-fast duration-100 text-red-600"
                      : "text-carching-pink "
                  }`}
                >
                  {layout_text[step].bottom}
                </p>
              </div>

              {layout_text[step].button_text ? (
                <>
                  {step !== 4 && (
                    <PinkButton
                      text="next"
                      loading={isLoading}
                      onClick={(e) => handleNext(e)}
                    />
                  )}
                </>
              ) : (
                <div className="p-2 py-4"></div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full flex justify-center items-center min-h-screen">
          <p>something went wrong</p>
        </div>
      )}
    </>
  );
};

export default MonthlyCheck;
